module.exports = __webpack_public_path__ + "6c2036a0879c51d509e5d970918fb2d8.svg";